import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import setAuthorization from '../utils/helpers/setAuthorization'
import { API_BASE_URL } from '../constants/api'

const libraryRepository = createApi({
	reducerPath: 'libraryRepository',
	baseQuery: fetchBaseQuery({
		prepareHeaders: setAuthorization,
		baseUrl: API_BASE_URL,
	}),
	tagTypes: ['LibraryLevel', 'LibraryContent'],
	endpoints: (builder) => ({
		getProficiency: builder.query<
			Array<{
				id: number
				nivel: string
				modulo_id: number
			}>,
			{ cursoId: number }
		>({
			query: ({ cursoId }) => ({
				url: `/v1/proficiency/course/${cursoId}`,
				method: 'GET',
			}),
			providesTags: ['LibraryLevel'],
		}),
		getUnits: builder.mutation<
			Array<{
				id: number
				nome: string
				topicos: Array<{
					id: number
					nome: string
				}>
			}>,
			{ courseId: number; moduleId: number }
		>({
			query: ({ courseId, moduleId }) => ({
				url: `/v1/courses/units/${moduleId}/${courseId}/units-and-topics`,
				method: 'GET',
			}),
			invalidatesTags: ['LibraryContent'],
		}),
		getUnitsRecorded: builder.mutation<
			Array<{
				id: number
				nome: string
				topicos: Array<{
					id: number
					nome: string
				}>
			}>,
			{ courseId: number }
		>({
			query: ({ courseId }) => ({
				url: `/v1/courses/units/${courseId}/units-and-topics`,
				method: 'GET',
			}),
			invalidatesTags: ['LibraryContent'],
		}),
		getLesson: builder.mutation<
			{
				id: number
				nome: string
				ordem: number
				unidade_id: number
				conteudo: string
				nextTopic: number
				status: string
			},
			{ topicId: number }
		>({
			query: ({ topicId }) => ({
				url: `/v1/courses/topics/by-id/${topicId}`,
				method: 'GET',
			}),
			invalidatesTags: ['LibraryContent'],
		}),
		completeLesson: builder.mutation<
			void,
			{ cursoId: number; usuarioId: number; topicoId: number }
		>({
			query: ({ cursoId, usuarioId, topicoId }) => ({
				url: `/v1/courses/topics/${cursoId}/completed`,
				method: 'POST',
				body: {
					usuarioId,
					topicoId,
				},
			}),
			invalidatesTags: ['LibraryContent'],
		}),
		getProgress: builder.query<
			{
				concluidos: Array<number>
				progresso: number
			},
			{ cursoId: number; userId: number }
		>({
			query: ({ cursoId, userId }) => ({
				url: `/v1/courses/topics/${cursoId}/progress/user/${userId}`,
				method: 'GET',
			}),
			providesTags: ['LibraryContent'],
		}),
	}),
})

export default libraryRepository
